export const BOARD_SIZE = 30
export const BOARD_SIZE_2 = 40
export const SPEED_MOVE = 120
export const PLAYER_HEALTH = 1600
export const MAX_ENEMIES = 1650